import { Button, Modal, Row } from "antd";
import { ReactNode, useMemo } from "react";
import image from "../../../../../images/bank-payment.svg";

type AchHelpModalProps = {
  isOpen: boolean;
  close: () => void;
};

export const AchHelpModal = ({ isOpen, close }: AchHelpModalProps) => {
  const title: ReactNode = useMemo(() => {
    return (
      <Row className="pt-6 px-8">
        <h3 className="h h3 w-500">How to find my bank details</h3>
      </Row>
    );
  }, []);

  const footer: ReactNode = useMemo(() => {
    return (
      <Row className="justify-end mt-8">
        <Button size="large" shape="round" onClick={close} type="primary">
          Got It
        </Button>
      </Row>
    );
  }, [close]);

  return (
    <Modal
      title={title}
      open={isOpen}
      onCancel={close}
      width={422}
      footer={footer}
      closable={false}
      className="ach-help"
    >
      <Row className="d-block pt-8 px-2 pb-3">
        <img src={image} alt="bank-img" width="100%" />
        <Row className="d-block mt-8">
          <p className="mt-0 mb-6">
            Find these numbers at the bottom of a paper check.
          </p>
          <p className="my-0">
            If you are unsure of any of these numbers, please contact your bank
            before continuing.
          </p>
        </Row>
      </Row>
    </Modal>
  );
};
